<template>
  <div>
    <div class="max-w-5xl mx-auto">
      <div class="space-y-16">
        <VList>
          <template #before>
            <div class="hidden lg:flex font-medium text-sm text-gray-600 mb-4 pr-2">
              <div class="w-32 px-4">Date</div>
              <div class="flex-1 px-4">Document</div>
              <div class="w-32 px-4 text-right">Amount</div>
              <div class="w-32 px-4 text-right">Balance</div>
            </div>
          </template>

          <template v-if="movements.length" #default>
            <template v-for="movement in movementsWithRunningBalance">
              <VListLine :key="`account_client_movement_${movement.uuid}`" :movement="movement" />
            </template>
          </template>

          <template v-else #default>
            <div class="odd:bg-gray-100 border border-gray-200 rounded p-4 text-center">
              No results found
            </div>
          </template>
        </VList>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import store from '@/store';
import VList from '@/components/Common/VList.vue';
import VListLine from '@/components/AccountRelationMovements/VListLine.vue';

export default {
  components: {
    VList,
    VListLine,
  },

  async beforeRouteEnter(to, from, next) {
    const { clientUuid: accountClientUuid } = to.params;

    try {
      await store.dispatch('ui/accountClientMovements/load', { accountClientUuid });
      next();
    } catch (error) {
      next(false);
    }
  },

  computed: {
    ...mapGetters('ui/accountClients', ['client']),
    ...mapGetters('ui/accountClientMovements', ['movements']),
    movementsWithRunningBalance() {
      const { balance = 0 } = this.client || {};
      let runningBalance = balance;
      return this.movements.reduce((acc, cur) => {
        const newCur = { ...cur, balance: runningBalance };
        runningBalance -= newCur.amount;
        return [...acc, newCur];
      }, []);
    },
  },
};
</script>
